import { render, staticRenderFns } from "./SwiperNavBtns.vue?vue&type=template&id=1d67529c&scoped=true&"
import script from "./SwiperNavBtns.vue?vue&type=script&lang=js&"
export * from "./SwiperNavBtns.vue?vue&type=script&lang=js&"
import style0 from "./SwiperNavBtns.vue?vue&type=style&index=0&id=1d67529c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d67529c",
  null
  
)

export default component.exports